import { Outlet, useNavigate, useLocation, Link, NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { ChevronLeft, Home, MapPin, PlayCircle, Sparkles } from "lucide-react";
import { api, trackEvent } from "@/lib/api";
import IdleScreensaver from "@/components/guest/IdleScreensaver";
import ReminderOverlay from "@/components/guest/ReminderOverlay";

export default function GuestLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [settings, setSettings] = useState({ property_name: "MYAZBNB.COM" });
  const isHome = location.pathname === "/";

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const p = location.pathname;
    const name = p === "/" ? "Home"
      : (p.split("/").filter(Boolean)[0] || "Home").replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    trackEvent("page_view", name);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-brand-bg text-brand-forest flex flex-col">
      <IdleScreensaver />
      <ReminderOverlay />
      <header
        data-testid="guest-header"
        className={`${isHome ? "hidden " : ""}sticky top-0 z-40 backdrop-blur-xl bg-white/70 border-b border-black/5`}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
          <div className="w-24">
            {!isHome && (
              <button
                data-testid="back-button"
                onClick={() => navigate(-1)}
                className="flex items-center gap-1 text-sm font-medium text-brand-forest/80 hover:text-brand-terracotta transition-colors active:scale-95"
              >
                <ChevronLeft size={20} /> Back
              </button>
            )}
          </div>
          <Link to="/" data-testid="header-title" className="font-display text-lg sm:text-xl tracking-tight text-brand-forest">
            {settings.property_name}
          </Link>
          <div className="w-24 flex justify-end">
            {!isHome && (
              <button
                data-testid="home-button"
                onClick={() => navigate("/")}
                className="flex items-center justify-center h-10 w-10 rounded-full bg-brand-forest text-white hover:bg-brand-terracotta transition-colors active:scale-95"
              >
                <Home size={18} />
              </button>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1 w-full pb-20 sm:pb-0">
        <Outlet />
      </main>

      {/* Mobile bottom nav */}
      <nav data-testid="mobile-bottom-nav" className="sm:hidden fixed bottom-0 inset-x-0 z-40 bg-brand-ocean text-white">
        <div className="grid grid-cols-4 h-20 divide-x divide-white/30">
          {[
            { to: "/", label: "HOME", icon: Home, end: true },
            { to: "/local-tips", label: "LOCAL", icon: MapPin },
            { to: "/guides", label: "TIPS", icon: PlayCircle },
            { to: "/add-ons", label: "ADD-ON", icon: Sparkles },
          ].map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to} to={t.to} end={t.end}
                data-testid={`bottom-nav-${t.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `flex flex-col items-center justify-center gap-1 text-[11px] font-semibold tracking-wide transition-colors ${isActive ? "text-white" : "text-white/70"}`
                }
              >
                <Icon size={22} />
                {t.label}
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
